import useSubState from '@/composables/use-sub-state';
import { fetchLoginInfo } from '@/services/login';
import type { LoginInfoResponse } from '@/types/login';
import { defineStore } from 'pinia';
import { computed } from 'vue';

export const useLoginStore = defineStore(
    'login',
    () => {
        const [loginInfo, getLoginInfo, clearLoginInfo] =
            useSubState<LoginInfoResponse>(fetchLoginInfo);
        const loggedIn = computed(() => !!loginInfo.data?.isVerzekeringnemerIngelogd);

        return {
            loginInfo,
            loggedIn,
            getLoginInfo,
            clearLoginInfo
        };
    },
    {
        persist: {
            pick: ['loginInfo.data']
        }
    }
);

export default useLoginStore;
